// reducer.js
type Group = "Quality Improvement" | "Quality Planning and Control" | "General Privilege";

export interface Permission {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: string | null;
  updated_by_id: string | null;
  is_deleted: boolean;
  deleted_at: string | null;
  name: string;
  code: string;
  group: string;
} 

export interface PermissionState {
  data: Permission[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const permissionInitialState: PermissionState = {
  data: [],
  error: null,
};

export const permissionReducer = (
  state: PermissionState = permissionInitialState,
  action: Action
): PermissionState => {
  switch (action.type) {
    case "FETCH_PERMISSIONS_SUCCESS":
      return { ...state, data: action.payload };
    case "FETCH_PERMISSIONS_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
